import { useQuery } from '@tanstack/react-query';
import type { SchoolTaxesDto } from '../../../models/taxes/school/school-taxes-details.dto';
import apiRequest from '../../../services/apiWrapper';
import { SCHOOL_TAX_PAYMENTS } from '../../../utils/constants/urlConstants';

async function fetchSchoolTaxes(startYear: number) {
  const params = new URLSearchParams();
  params.append('startYear', startYear.toString());

  const url = `${SCHOOL_TAX_PAYMENTS}/students/price-plan?${params.toString()}`;

  const response = await apiRequest.get<SchoolTaxesDto>(url);

  return response.data.pricePlans;
}

export function useGetSchoolTaxes(startYear: number) {
  return useQuery({
    queryKey: ['school-taxes', startYear],
    queryFn: () => fetchSchoolTaxes(startYear),
    enabled: !!startYear,
    throwOnError: false,
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
    gcTime: 10 * 60 * 1000, // Keep in cache for 10 minutes
  });
}
